const commonLoanProposalActionTypes = {
	/*************** START GET CENTER WISE LOAN PROPOSAL LIST ***************/
	GET_LOAN_PROPOSAL_LIST_START: 'get_loan_proposal_list_start',
	GET_LOAN_PROPOSAL_LIST_SUCCESS: 'get_loan_proposal_list_success',
	GET_LOAN_PROPOSAL_LIST_FAILURE: 'get_loan_proposal_list_failure',
	GET_LOAN_PROPOSAL_LIST_RESPONSE_RESET: 'get_loan_proposal_list_response_reset',
	GET_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED: 'get_loan_proposal_list_response_changed',
	/*************** END GET CENTER WISE LOAN PROPOSAL LIST ***************/

	/** ***************** REVERT LOAN INDEX START *********************** */
	REVERT_LOAN_INDEX_START: 'revert_loan_index_start',
	REVERT_LOAN_INDEX_SUCCESS: 'revert_loan_index_success',
	REVERT_LOAN_INDEX_FAILURE: 'revert_loan_index_failure',
	REVERT_LOAN_INDEX_RESPONSE_RESET: 'revert_loan_index_response_reset',
	REVERT_LOAN_INDEX_RESPONSE_CHANGED: 'revert_loan_index_response_changed',
	/** ***************** REVERT LOAN INDEX END *********************** */

	/** ***************** GET GROUP MEMBER LIST START *********************** */
	GET_WHOLE_GROUP_MEMBER_LIST_START: 'get_whole_group_member_list_start',
	GET_WHOLE_GROUP_MEMBER_LIST_SUCCESS: 'get_whole_group_member_list_success',
	GET_WHOLE_GROUP_MEMBER_LIST_FAILURE: 'get_whole_group_member_list_failure',
	GET_WHOLE_GROUP_MEMBER_LIST_RESPONSE_RESET: 'get_whole_group_list_member_response_reset',
	GET_WHOLE_GROUP_MEMBER_LIST_RESPONSE_CHANGED: 'get_whole_group_list_member_response_changed',
	/** ***************** GET GROUP MEMBER LIST END *********************** */

	/** *****************  FETCH PARTICULAR LOAN INDEX START *********************** */
	FETCH_PARTICULAR_LOAN_INDEX_START: 'fetch_particular_loan_index_start',
	FETCH_PARTICULAR_LOAN_INDEX_SUCCESS: 'fetch_particular_loan_index_sucess',
	FETCH_PARTICULAR_LOAN_INDEX_FAILURE: 'fetch_particular_loan_index_failure',
	FETCH_PARTICULAR_LOAN_INDEX_RESPONSE_RESET_START:
		'fetch_particular_loan_index_response_reset_start',
	FETCH_PARTICULAR_LOAN_INDEX_RESPONSE_CHANGED: 'fetch_particular_laon_index_response_changed',
	/** *****************  FETCH PARTICULAR LOAN INDEX END*********************** */

	/** *****************  FETCH HOLIDAY LIST START *********************** */
	FETCH_HOLIDAY_LIST_START: 'fetch_holiday_list_start',
	FETCH_HOLIDAY_LIST_SUCCESS: 'fetch_holiday_list_success',
	FETCH_HOLIDAY_LIST_FAILURE: 'fetch_holiday_list_failure',
	FETCH_HOLIDAY_LIST_RESPONSE_RESET: 'fetch_holiday_list_response_reset',
	FETCH_HOLIDAY_LIST_RESPONSE_CHANGED: 'fetch_holiday_list_response_changed',
	/** *****************  FETCH HOLIDAY LIST END*********************** */

	/** *****************  GET MEMBER LOAN PRODUCT EXIST START *********************** */
	GET_MEMBER_LOAN_PRODUCT_EXIST_START: 'get_member_loan_product_exist_start',
	GET_MEMBER_LOAN_PRODUCT_EXIST_SUCCESS: 'get_member_loan_product_exist_success',
	GET_MEMBER_LOAN_PRODUCT_EXIST_FAILURE: 'get_member_loan_product_exist_failure',
	GET_MEMBER_LOAN_PRODUCT_EXIST_RESPONSE_RESET: 'get_member_loan_product_exist_response_reset',
	GET_MEMBER_LOAN_PRODUCT_EXIST_RESPONSE_CHANGED:
		'get_member_loan_product_exist_response_changed',
	/** *****************  GET MEMBER LOAN PRODUCT EXIST END*********************** */

	/** *****************  APPROVE LOAN INDEX START *********************** */
	APPROVE_LOAN_INDEX_START: 'APPROVE_LOAN_INDEX_START',
	APPROVE_LOAN_INDEX_SUCCESS: 'APPROVE_LOAN_INDEX_SUCCESS',
	APPROVE_LOAN_INDEX_FAILURE: 'APPROVE_LOAN_INDEX_FAILURE',
	APPROVE_LOAN_INDEX_RESPONSE_RESET_START: 'APPROVE_LOAN_INDEX_RESPONSE_RESET_START',
	APPROVE_LOAN_INDEX_RESPONSE_CHANGED: 'APPROVE_LOAN_INDEX_RESPONSE_CHANGED',
	/** ***************** APPROVE LOAN INDEX END*********************** */

	/** ***************** DELETE LOAN INDEX DETAILS START *********************/
	DELETE_LOAN_INDEX_START: 'DELETE_LOAN_INDEX_START',
	DELETE_LOAN_INDEX_SUCCESS: 'DELETE_LOAN_INDEX_SUCCESS',
	DELETE_LOAN_INDEX_FAILURE: 'DELETE_LOAN_INDEX_FAILURE',
	DELETE_LOAN_INDEX_RESPONSE_RESET_START: 'DELETE_LOAN_INDEX_RESPONSE_RESET_START',
	DELETE_LOAN_INDEX_RESPONSE_CHANGED: 'DELETE_LOAN_INDEX_RESPONSE_CHANGED',
	/** ***************** DELETE LOAN INDEX DETAILS START *********************** */

	/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS START *********************/
	DELETE_MEMBER_IN_LOAN_INDEX_START: 'DELETE_MEMBER_IN_LOAN_INDEX_START',
	DELETE_MEMBER_IN_LOAN_INDEX_SUCCESS: 'DELETE_MEMBER_IN_LOAN_INDEX_SUCCESS',
	DELETE_MEMBER_IN_LOAN_INDEX_FAILURE: 'DELETE_MEMBER_IN_LOAN_INDEX_FAILURE',
	DELETE_MEMBER_IN_LOAN_INDEX_RESPONSE_RESET_START:
		'DELETE_MEMBER_IN_LOAN_INDEX_RESPONSE_RESET_START',
	DELETE_MEMBER_IN_LOAN_INDEX_RESPONSE_CHANGED: 'DELETE_LMEMBER_IN_LOAN_INDEX_RESPONSE_CHANGED',
	/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS END *********************/

	/** ***************** REVERT LOAN PROPOSAL APPROVE DETAILS START *********************/
	REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_START: 'revert_loan_proposal_approve_details_start',
	REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_SUCCESS: 'revert_loan_proposal_approve_details_success',
	REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_FAILURE: 'revert_loan_proposal_approve_details_failure',
	REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_RESPONSE_RESET:
		'revert_loan_proposal_approve_details_response_reset',
	REVERT_LOAN_PROPOSAL_APPROVE_DETAILS_RESPONSE_CHANGED:
		'revert_loan_proposal_approve_details_response_changed',
	/** ***************** REVERT LOAN PROPOSAL APPROVE DETAILS END *********************/

	/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
	HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_START: 'hdfc_create_individual_loan_qrcode_start',
	HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_SUCCESS: 'hdfc_create_individual_loan_qrcode_success',
	HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_FAILURE: 'hdfc_create_individual_loan_qrcode_failure',
	HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_RESPONSE_RESET:
		'hdfc_create_individual_loan_qrcode_response_reset',
	HDFC_CREATE_INDIVIDUAL_LOAN_QRCODE_RESPONSE_CHANGED:
		'hdfc_create_individual_loan_qrcode_response_changed',
	/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

	/*********** GET APPRAISAL LOG START ************************ */
	GET_APPRAISAL_LOG_START: 'get_appraisal_log_start',
	GET_APPRAISAL_LOG_SUCCESS: 'get_appraisal_log_success',
	GET_APPRAISAL_LOG_FAILURE: 'get_appraisal_log_failure',
	GET_APPRAISAL_LOG_RESPONSE_RESET: 'get_appraisal_log_response_reset',
	GET_APPRAISAL_LOG_RESPONSE_CHANGED: 'get_appraisal_log_response_changed',
	/*********** GET APPRAISAL LOG END ************************ */

	/*********** MOVE TO PARTICULAR APPRAISAL START ************************ */
	MOVE_TO_PARTICULAR_APPRAISAL_START: 'move_to_particular_appraisal_start',
	MOVE_TO_PARTICULAR_APPRAISAL_SUCCESS: 'move_to_particular_appraisal_success',
	MOVE_TO_PARTICULAR_APPRAISAL_FAILURE: 'move_to_particular_appraisal_failure',
	MOVE_TO_PARTICULAR_APPRAISAL_RESPONSE_RESET: 'move_to_particular_appraisal_response_reset',
	MOVE_TO_PARTICULAR_APPRAISAL_RESPONSE_CHANGED: 'move_to_particular_appraisal_response_changed',
	/*********** MOVE TO PARTICULAR APPRAISAL END ************************ */

	/*********** LOAN APPROVE OTP START ************************ */
	LOAN_APPROVE_OTP_START: 'loan_approve_otp_start',
	LOAN_APPROVE_OTP_SUCCESS: 'loan_approve_otp_success',
	LOAN_APPROVE_OTP_FAILURE: 'loan_approve_otp_failure',
	LOAN_APPROVE_OTP_RESPONSE_RESET: 'loan_approve_otp_response_reset',
	LOAN_APPROVE_OTP_RESPONSE_CHANGED: 'loan_approve_otp_response_changed',
	/*********** LOAN APPROVE OTP END ************************ */
};
export default commonLoanProposalActionTypes;
